import Axios from "axios"
import config from "../app.config"

export var mailSendResumeService;
export default mailSendResumeService = {
    getMailSendResume,
    showMailSendResume,
    getMailTemplate,
}
async function getMailSendResume(payload){
    return await Axios.get(`${config.LOCAL_API_URL}/mail-send-resume`,{params: payload})
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error);
    })
}
async function showMailSendResume(id){
    return await Axios.get(`${config.LOCAL_API_URL}/mail-send-resume/` + id)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function getMailTemplate(payload){
    return await Axios.get(`${config.LOCAL_API_URL}/mail-send-resume/template`,{params: payload})
        .then(response => {
            if(response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error =>{
            return Promise.reject(error);
        })
}